import { Box } from '@mui/material';
import React from 'react';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import About from './pages/About';
import AllProjects from './pages/AllProjects';
import CalendarManagement from './pages/CalendarManagement';
import Contact from './pages/Contact';
import CoreModules from './pages/CoreModules';
import DetailedProduct from './pages/DetailedProduct';
import DetailedProductSecondPage from './pages/DetailedProductSecondPage';
import FAQ from './pages/FAQ';
import Home from './pages/Home';
import IntelligentAssistant from './pages/IntelligentAssistant';
import MeetingAssistant from './pages/MeetingAssistant';
import OrganizationAutomation from './pages/OrganizationAutomation';
import OrgChatAI from './pages/OrgChatAI';
import PlannerTaskManagement from './pages/PlannerTaskManagement';
import SmartOrganization from './pages/SmartOrganization';
import Textra from './pages/Textra';
import Weblog from './pages/Weblog';
import AllProducts from './pages/AllProducts';

// Wrapper component to handle conditional footer rendering
const AppContent = () => {
  const location = useLocation();
  const isContactPage = location.pathname === '/contact';

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/all-projects" element={<AllProjects />} />
        <Route path="/all-products" element={<AllProducts />} />
        <Route path="/detailed-product" element={<DetailedProduct />} />
        {/* <Route path="/detailed-product-2" element={<DetailedProductSecondPage />} /> */}
        <Route path="/smart-organization" element={<SmartOrganization />} />
        <Route path="/core-modules" element={<CoreModules />} />
        <Route path="/orgchat-ai" element={<OrgChatAI />} />
        <Route path="/planner-task-management" element={<PlannerTaskManagement />} />
        <Route path="/calendar-management" element={<CalendarManagement />} />
        <Route path="/organization-automation" element={<OrganizationAutomation />} />
        <Route path="/intelligent-assistant" element={<IntelligentAssistant />} />
        <Route path="/meeting-assistant" element={<MeetingAssistant />} />
        <Route path="/textra" element={<Textra />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/weblog" element={<Weblog />} />
      </Routes>
      
      {!isContactPage && <Footer />}
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <ScrollToTop />
          <Box
            sx={{
              minHeight: '100vh',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Header />
            <AppContent />
          </Box>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;

